<script setup lang="ts">
/**
 * ADMIN-T013 — global error boundary. Captures errors thrown by descendant
 * components and renders a local fallback so the rest of the shell keeps working.
 */
import { onErrorCaptured, ref } from 'vue';

const error = ref<Error | null>(null);

onErrorCaptured((err) => {
  error.value = err as Error;
  return false; // do not re-throw — confine fallout to this subtree
});

function retry() {
  error.value = null;
}
</script>

<template>
  <template v-if="error">
    <div class="boundary">
      <h3>该区域加载失败</h3>
      <p>{{ error.message }}</p>
      <button
        type="button"
        @click="retry"
      >
        重试
      </button>
    </div>
  </template>
  <template v-else>
    <slot />
  </template>
</template>

<style scoped>
.boundary {
  padding: 24px;
  margin: 24px;
  border: 1px dashed #f87171;
  border-radius: 6px;
  background: #fef2f2;
  color: #991b1b;
}
button {
  margin-top: 8px;
  padding: 6px 12px;
  border: 1px solid #b91c1c;
  border-radius: 4px;
  background: #fff;
  color: #b91c1c;
  cursor: pointer;
}
</style>
